/**
 * @name UserService
 * @description Servicio para la gestión de la información de usuario
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Cambia la contraseña del usuario
 * @param request { ContraseñaAnterior: string, ContraseñaNueva: string, ConfirmarContraseña: string } 
 * @return {any} promise
 */
const postPass = (request) => {
  let URL = `${BASE_URL}/Usuario/CambiarContrasena/`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

export const UserService = {
  postPass
};